export interface CurrencyLabel {
  value: string;
  label: string;
}

export const currencies: CurrencyLabel[] = [
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "GBP", label: "GBP" },
];
